var map = new Map()
map.set('1', '/websitephoto')
map.set('2', '/websitecooperation')
map.set('3', '/websiteinformation')
map.set('4', '/enterproserecruit')
map.set('5', '/enterproseteam')
map.set('6', '/websitecontact')

export const getmenuvalue = function (item) {
  let key = map.get(item.relationId + '')
  if (!key) {
    key = '/generalpage/' + item.relationId
  }
  return key

}
